import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  AgentUnavailableParams,
  AgentUnavailableReason,
  agentRouteCommands,
  agentRoutePaths,
} from '../agent/agent-route-paths';
import { Middleware, NotFoundErrorDetailCodeEnum } from '../connectors/backend';

async function lostReason(
  response: Response,
): Promise<AgentUnavailableReason | null> {
  if (response.status === 403) return 'forbidden';
  if (response.status !== 404) return null;
  const body = (await response.json().catch(() => null)) as {
    code?: string;
  } | null;
  return body?.code === NotFoundErrorDetailCodeEnum.ModuleNotFound
    ? 'module'
    : null;
}

/**
 * Inside the agents app, a 403 or a module that went off sends the rep to the page saying why.
 * Elsewhere (the module settings page) the answer stays with the caller.
 */
export function salesAccessLost(injector: Injector): Middleware {
  return {
    async post({ response }) {
      const router = injector.get(Router);
      const firstSegment = router.parseUrl(router.url).root.children['primary']
        ?.segments[0]?.path;
      if (firstSegment !== agentRoutePaths.root) return;

      const reason = await lostReason(response);
      if (!reason) return;
      const queryParams: AgentUnavailableParams = { reason };
      void router.navigate(agentRouteCommands.unavailable(), { queryParams });
    },
  };
}
